/**
 * 屏幕录制工具（阅卷过程录屏）
 * 点击「考试阅卷」开始录制，完成所有阅卷后结束录制并自动下载到本地
 * 上传由用户在阅卷视频列表的上传弹窗中手动完成
 * 文件名格式：开始时间-结束时间.mp4，例：20260314121223-20260314122321.mp4
 */

let mediaRecorder = null
let mediaStream = null
let chunks = []
let startTime = null

// 格式化为 yyyyMMddHHmmss
function formatTime(date) {
  const pad = n => String(n).padStart(2, '0')
  return (
    date.getFullYear() +
    pad(date.getMonth() + 1) +
    pad(date.getDate()) +
    pad(date.getHours()) +
    pad(date.getMinutes()) +
    pad(date.getSeconds())
  )
}

// 优先使用 mp4，不支持则降级 webm
function getMimeType() {
  const types = ['video/mp4', 'video/webm;codecs=h264', 'video/webm']
  return types.find(t => window.MediaRecorder && MediaRecorder.isTypeSupported(t)) || ''
}

function saveBlob() {
  if (!chunks.length) return
  const mimeType = mediaRecorder ? mediaRecorder.mimeType : ''
  const ext = mimeType.includes('mp4') ? 'mp4' : 'webm'
  const blob = new Blob(chunks, { type: mimeType || 'video/webm' })
  const endTime = new Date()
  const fileName = `${formatTime(startTime)}-${formatTime(endTime)}.${ext}`
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = fileName
  a.click()
  window.URL.revokeObjectURL(url)
}

function reset() {
  if (mediaStream) {
    mediaStream.getTracks().forEach(track => track.stop())
  }
  mediaRecorder = null
  mediaStream = null
  chunks = []
  startTime = null
}

export function isRecording() {
  return !!mediaRecorder && mediaRecorder.state === 'recording'
}

/**
 * 开始录制（用户需在浏览器弹窗中选择要共享的屏幕）
 * @returns {Promise<boolean>} 是否成功开始录制
 */
export async function startRecording() {
  if (isRecording()) return true
  // 存在上次未正常结束的录制，先结束并保存
  if (mediaRecorder) stopRecording()
  const stream = await navigator.mediaDevices.getDisplayMedia({
    video: true,
    audio: true,
  })
  const mimeType = getMimeType()
  chunks = []
  startTime = new Date()
  mediaStream = stream
  mediaRecorder = new MediaRecorder(stream, mimeType ? { mimeType } : undefined)
  mediaRecorder.ondataavailable = e => {
    if (e.data && e.data.size > 0) chunks.push(e.data)
  }
  mediaRecorder.onstop = () => {
    saveBlob()
    reset()
  }
  // 用户通过浏览器控件主动停止共享时，自动保存已录制内容
  stream.getVideoTracks()[0].onended = () => {
    stopRecording()
  }
  mediaRecorder.start(1000)
  return true
}

// 结束录制并保存文件
export function stopRecording() {
  if (mediaRecorder && mediaRecorder.state !== 'inactive') {
    mediaRecorder.stop()
  } else {
    reset()
  }
}
